import { Notification, RootState } from "../types";

export const getNotification = (state: RootState): Notification => state.notification.notification;
